<div class="content" (click)="show()">
  <div class="username">
    <p>{{username}}</p>
  </div>
  <img [draggable]="false" class="img1" [src]="imageSource">
</div>
